import { createSlice } from "@reduxjs/toolkit";
import { Job } from "../models/Job";

const JobsInitialState: {
	jobsData: Job[];
	blockButtons: boolean;
} = {
	jobsData: [],
	blockButtons: false,
};

export const JobsReducer = createSlice({
	name: "__",
	initialState: JobsInitialState,
	reducers: {
		setJobs(state, { payload }) {
			state.jobsData = payload;
		},
		setBlockButtons(state, { payload }) {
			state.blockButtons = payload;
		},
	},
});
